module.exports = __webpack_public_path__ + "media/passing_touchdown_left.d215a9b6.mp4";